"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedMessage = FormattedMessage;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_js_1 = require("./hooks.js");
function FormattedMessage({ id, values, }) {
    const translator = (0, hooks_js_1.useTranslator)();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: translator[id](values) });
}
//# sourceMappingURL=FormattedMessage.js.map